/* eslint-disable sonarjs/no-nested-conditional */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { useTranslation } from 'react-i18next';

const HazardComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.hazard_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Hazard Type</th>
            <td>{t(`hazard.type.${report.hazard_type.toLowerCase()}`)}</td>
          </tr>
          {report.hazard_type === 'weather' ? (
            <tr>
              <th>Weather</th>
              <td>
                {report.hazard_subtypes
                  .map((w) => t(`hazard.weather.${w.toLowerCase()}`))
                  .join(', ')}
              </td>
            </tr>
          ) : report.hazard_type === 'crash' ? (
            <tr>
              <th>Crash</th>
              <td>
                {report.hazard_subtypes.map((w) => t(`hazard.crash.${w.toLowerCase()}`)).join(', ')}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default HazardComponent;
